module.exports = __webpack_public_path__ + "img/Job-info.45698c3f.svg";